import * as warning from 'warning';
import { Feature } from './Feature';
import { Config } from 'common/api/models/Config';

export const checkFeatureEnabled = (flag: Feature, config?: Config) => {
  warning(
    !!config && !!config.config && config.config.hasOwnProperty(Feature[flag]),
    `${Feature[flag]} does not exist in the feature config!`
  );

  return !!config && !!config.config && !!config.config[Feature[flag]];
};



// WEBPACK FOOTER //
// ./src/common/features/checkFeatureEnabled.ts